// extracted by mini-css-extract-plugin
export default {"constructionSiteNameInput":"ActivateConstructionSiteSummary_constructionSiteNameInput__6kGIF"};